/**
 * Decide un solo movimiento del tour.
 * Si la ruta no se puede abrir, o el intento anterior no llegó, no vuelve a navegar.
 */
export function decidirNavegacionTour({ pagina, pathname, permitido, yaIntento, targetExiste }) {
  if (!pagina) {
    return { navegar: false, informativo: false }
  }
  if (!permitido || (yaIntento && pathname !== pagina)) {
    return { navegar: false, informativo: true }
  }
  if (pathname !== pagina) {
    return { navegar: true, informativo: false }
  }
  if (targetExiste === false) {
    return { navegar: false, informativo: true }
  }
  return { navegar: false, informativo: false }
}
